export const FETCH_ERRORS = 'errors-dictionary/FETCH_ERRORS'
